import React from "react";
import { CHANGE_IS_CLOSEABLE, CHANGE_MODAL_STATE, CHANGE_MODAL_CONTENT, CHANGE_MODAL_ANIMATION } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export interface ModalState {
    modalState: "modal-display" | "modal-dismiss" | "modal-fade-in" | "modal-fade-out";
    isCloseable: boolean;
    fadeOut: boolean;
    content?: React.ReactElement;
    crossButtonAriaLabel?: string;
    className?: string;
    contentAriaLabel?: string;
    title?: string;
    // Populate the following if the modal language can be changed while opened
    translationFile?: string;
    crossButtonAriaLabelKey?: string;
    contentAriaLabelKey?: string;
    titleKey?: string;
}

// Define an initial state value for the app
const initialState: ModalState = {
    modalState: "modal-dismiss",
    isCloseable: true,
    fadeOut: true
}
  
function modalReducer(state = initialState, action: AppAction) {

    const { payload, value } = action;

    switch (action.type) {
        case CHANGE_MODAL_STATE:
            return {
                ...state,
                modalState: value
            }
        case CHANGE_IS_CLOSEABLE:
            return {
                ...state,
                isCloseable: value
            }

        case CHANGE_MODAL_CONTENT: {
            const recordPayload = (payload as Record<string, Record<string, unknown>>).data;
            return {
                ...state,
                content: recordPayload.content,
                className: recordPayload.className,
                title: recordPayload.title,
                contentAriaLabel: recordPayload.contentAriaLabel,
                crossButtonAriaLabel: recordPayload.crossButtonAriaLabel,
                translationFile: recordPayload.translationFile,
                titleKey: recordPayload.titleKey,
                contentAriaLabelKey: recordPayload.contentAriaLabelKey,
                crossButtonAriaLabelKey: recordPayload.crossButtonAriaLabelKey
            }
        }

        case CHANGE_MODAL_ANIMATION: {
            return {
                ...state,
                fadeOut: value
            }
        }
        default:
            return state;
    }
}

export default modalReducer;